<div [ngSwitch]="page">
    <cm-entries
        *ngSwitchCase="PAGES.ENTRIES"
        [step]="step"
        [stepEditableStatus]="stepEditableStatus"
        (close)="closeModal()"
        (dismissModal)="dismissModal()"
        (goToPage)="goToPage($event)"
        (openEntryForm)="onOpenEntryForm($event)"
    ></cm-entries>
    <cm-log-submit-content
        *ngSwitchCase="PAGES.SUBMIT_CONTENT"
        [step]="step"
        [workflowTypeId]="workflowTypeId"
        (goToPage)="goToPage($event)"
        (submitForm)="submit($event)"
    ></cm-log-submit-content>
    <cm-log-corrections-content
        *ngSwitchCase="PAGES.CORRECTIONS_CONTENT"
        [entries]="entries"
        [step]="step"
        (goToPage)="goToPage($event)"
        (close)="closeModal()"
    ></cm-log-corrections-content>
    <cm-crud-entry
        *ngSwitchCase="PAGES.CRUD_ENTRY"
        [entry]="selectedEntry"
        [step]="step"
        [stepEditableStatus]="stepEditableStatus"
        (goToPage)="goToPage($event)"
    ></cm-crud-entry>
    <cm-invitation
        *ngSwitchCase="PAGES.INVITATION"
        [step]="step"
        [stepEditableStatus]="stepEditableStatus"
        (close)="closeModal()"
        (dismissModal)="dismissModal()"
        (selectPage)="onPageChange($event)"
    ></cm-invitation>
    <cm-reset-confirm-content
        *ngSwitchCase="PAGES.RESET_CONFIRM"
        (cancel)="goToPage(PAGES.ENTRIES)"
        (confirm)="onResetConfirm()"
    >
    </cm-reset-confirm-content>
    <cm-confirm-inv-close
        *ngSwitchCase="PAGES.INV_CONFIRM"
        (close)="closeModal()"
        (selectPage)="onPageChange($event)"
    ></cm-confirm-inv-close>
</div>
